import { amplitude } from './client';
import type { AmplitudeEventName, AmplitudeEvents } from './types';

export const trackEvent = <T extends AmplitudeEventName>(name: T, props: AmplitudeEvents[T]): void => {
  amplitude.track(name, props);
};
